import React, { Component } from 'react';
import cn from 'classnames';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';

import s from './Input.css';

const styles = {
  underline: {
    '&:before': {
      // underline color when textfield is inactive
      borderBottom: '2px solid #bbb',
    },
    '&:after': {
      // underline color when textfield is active
      borderBottom: '2px solid #8fb450',
    },
    '&:hover:not($disabled):not($focused):not($error):before': {
      // underline color when hovered
      borderBottom: '2px solid #777 !important',
    },
  },
};

@withStyles(styles)
export default class Input extends Component {
  render() {
    const { classes, className, InputProps, ...rest } = this.props;

    return (
      <TextField
        InputProps={InputProps}
        className={cn(s.textField, className)}
        {...rest}
      />
    );
  }
}

Input.propTypes = TextField.propTypes;
